<template>
  <div class="container">
    <div class="d-flex justify-content-between px-5">
      <div></div>
      <!-- <h5 class="py-3">{{lessonResource.data.length!==0? $t('select_resources_download'):'沒有資源'}}</h5> -->
      <img class="back-icon pointer my-4" @click="previousPage" style="height:20px" src="../../../assets/image/icon/close_lesson.png" />
    </div>
    <div class="row pt-3 pb-3">
      <div class="col-lg-2 col-md-4 col-sm-6" v-for="resource in lessonResource" :key="resource.id" :lang="resource.language">
        <div class="unit-box my-2 mx-2">
          <a download :href="resource.dataURL">
            <img style="width:100%" :src="require(`../../../assets/image/cloud/btn_file_zip.png`)">
            <h5 class="card-text px-2">{{ resource.sceneName }}</h5>
          </a>
        </div>
      </div>
    </div>
    <!-- <pagination v-if="lessonResource.pageCount>1" :current="this.currentPage" :total="lessonResource.pageCount" v-on:page="goPage" /> -->
  </div>
</template>

<script>
import api from '../../../store/api'
import Pagination from '../../../components/Pagination'

export default {

  name: 'ARResource',
  components: {
    Pagination
  },
  data () {
    return {
      lessonResource: [],
      currentPage: 1,
      pageSize: 24
    }
  },

  computed: {
  },
  mounted () {
    this.getLessonResource()
  },

  methods: {
    goPage (page) {
      // this.currentPage = page
      this.getLessonResource()
    },
    goLessonPage () {
      this.$router.push({name: 'c_lesson', params: { id: this.$route.params.id }})
    },
    async getLessonResource () {
      // let params = {
      //   pageIndex: this.currentPage,
      //   pageSize: this.pageSize,
      //   category: this.$route.params.category
      // }
      const { data } = await api.get(`/VR/Resource`)
      // if (data.status === 'OK') {
      this.lessonResource = data
      // }
    },
    previousPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .unit-box {
		cursor: pointer;
		position: relative;
		h5 {
      width: 100%;
      font-size: 1rem;
			position: absolute;
			bottom: 30px;
			color: black;
    }
    &:hover {
      // -webkit-filter: drop-shadow(0px 0px 8px #a1a1a1);
      filter: drop-shadow(0px 0px 8px #a1a1a1)
    }
	}
</style>



// WEBPACK FOOTER //
// Resource.vue?75812336